import React, { Fragment, useContext, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import logo from "../../assets/images/logo.png";
import Table from "../../components/table";
import { CarContext } from "../../contexts/carProvider";
import { useAuth } from "../../hooks/useAuth";
import styles from "./style.module.css";

const PrintPDF = ({
  reference,
  rows,
  columns,
  limitData,
  selectedPage,
  footerColumns,
  downloadLoading = false,
  dateRangeValue,
  selectedCategory,
}) => {
  const [carName, setCarName] = useState("");
  const { auth } = useAuth();
  const { cars } = useContext(CarContext);
  const [screenWidth, setScreenWidth] = useState({ width: window.innerWidth, height: window.innerHeight });

  useEffect(() => {
    const car = cars.find((c) => c._id === auth.currentCar);
    setCarName(car?.name);
  }, [cars, auth.currentCar]);

  useEffect(() => {
    setScreenWidth({ width: window.innerWidth, height: window.innerHeight })
  }, [])

  return ReactDOM.createPortal(
    <Fragment>
      {downloadLoading && (
        <Fragment>
          <div className={styles.body_print_loader} style={{ width: screenWidth.width, height: screenWidth.height }}>
            <div className={styles.body_print_loader_inner} />
          </div>
        </Fragment>
      )}
      <div className={`${styles.body_print} ${downloadLoading ? styles.body_print_loading : ""}`} ref={reference}>
        <div className={styles.body_print_wrapper}>
          <div className={styles.body_print_head}>
            <div className={styles.bph_logo_car}>
              <div className={styles.bph_logo}>
                <img src={logo} alt="logo" />
              </div>
              <div className={styles.bph_car_name}>{carName}</div>
            </div>
            <div className={styles.bph_title}>Report</div>
            <div className={styles.bph_date_category}>
              {dateRangeValue?.startDate && dateRangeValue?.endDate && (
                <div className={styles.bph_date}>
                  {`${dateRangeValue.startDate} - ${dateRangeValue.endDate}`}
                </div>
              )}
              {selectedCategory?.title && (
                <div className={styles.bph_category}>
                  {selectedCategory?.title}
                </div>
              )}
            </div>
          </div>
          <Table
            rows={rows}
            columns={columns}
            footerColumns={footerColumns}
            selectedPage={selectedPage}
            loading={false}
            limitData={limitData}
            totalData={rows.length}
          />
        </div>
      </div>
    </Fragment>,
    document.body
  );
};

export default PrintPDF;
